import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { Pagination } from '@mui/material';
import axios from 'axios';
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { deleteItem, showTableResponse } from '../common-helpers/commonServices';
import UGC_AboutsModal from './UGC_AboutsModal';

const UGC_Abouts = () => {
    const childRef = useRef();
    const [blogs, setBlogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState([]);
    const [loadBlogs, setBlogsLoading] = useState(false);

    // search functionality    
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        const filteredBatches = blogs?.filter(
            item => item?.Title?.toLowerCase().includes(searchTerm?.toLowerCase())
        );
        setChecked(filteredBatches || []);
    }, [searchTerm, blogs])
    const handleSearch = (e) => {
        setSearchTerm(e.target.value)
    }

    const handleMoveOrder = async (index, direction) => {
        if (searchTerm) {
            toast.warning("Please clear search before reordering");
            return;
        }

        const actualIndex = firstIndex + index;
        const newBlogs = [...blogs];
        const targetIndex = direction === 'up' ? actualIndex - 1 : actualIndex + 1;

        if (targetIndex < 0 || targetIndex >= newBlogs.length) return;

        // Swap items
        [newBlogs[actualIndex], newBlogs[targetIndex]] = [newBlogs[targetIndex], newBlogs[actualIndex]];

        // Update DisplayOrder based on new index
        const updatedBlogs = newBlogs.map((item, idx) => ({
            ...item,
            DisplayOrder: idx + 1
        }));

        setBlogs(updatedBlogs);
        setChecked(updatedBlogs);

        // Prepare data for backend
        const orderData = updatedBlogs.map(item => ({
            Sn: item.Sn,
            DisplayOrder: item.DisplayOrder
        }));

        try {
            await axios.post(BACKEND_SERVER_URL + '/ugc/updateAboutOrder', orderData);
            toast.success("Order updated");
        } catch (error) {
            console.error("Error updating order:", error);
            toast.error("Failed to update order");
            setBlogsLoading(!loadBlogs);
        }
    };

    //set Table data
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/ugc/getAbouts').then((res) => {
            let blogs = res.data.data;
            setBlogs(blogs);
            setChecked(blogs);

        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message);
        })
    }, [loadBlogs])

    const pageSize = 50;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex) || [];
    const npage = Math.ceil((checked?.length || 0) / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)

    const handlePageChange = (e, p) => {
        setCurrentPage(parseInt(p));
    }

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">
                                <div className=' col-8 d-flex justify-content-between'>
                                    <div className="col-sm-3">
                                        <button type="button" className="btn btn-dark btn-sm me-2"
                                            onClick={() => childRef.current.openModal()}
                                        >
                                            + Add UGC Home Page
                                        </button>
                                    </div>
                                    <div className="col-sm-4">
                                    </div>
                                </div>

                                <div className="input-group search-area mb-md-0 mb-3">
                                    <input type="text" className="form-control" onChange={handleSearch} value={searchTerm} placeholder="Search here..." />
                                    <span className="input-group-text"><Link to={"#"}>
                                        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF" />
                                        </svg>
                                    </Link></span>
                                </div>
                            </div>

                        </div>
                        <div className=" d-sm-flex text-center justify-content-between align-items-center">
                            <div className='dataTables_info text-dark'>
                                Records: {checked.length}
                            </div>
                            <div className=" col-7 dataTables_paginate paging_simple_numbers d-flex justify-content-end align-items-center  mb-0 pt-2"
                                id="example-student_wrapper">
                                <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={handlePageChange} />
                            </div>
                        </div>
                        <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                            <div className="dataTables_wrapper no-footer">
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }}>
                                            <tr className='text-center text-dark border border-left'>
                                                <th className=' custom-table-header  p-2'>Sl.No.</th>
                                                <th className='p-2  custom-table-header text-center '>ORDER</th>
                                                <th className='p-2  custom-table-header text-start '>TITLE</th>
                                                <th className='p-2  custom-table-header text-center '>ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    <td className='text-center p-1 column-width' style={{ border: "1px solid #cccccc", width: "65px" }} ><h6 className="text-primary  mb-0"> {ind + 1 + firstIndex}</h6></td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "120px" }}>
                                                        <div className="d-flex align-items-center justify-content-center">
                                                            {/* <FaArrowUp
                                                                className={`me-2 ${ (ind + firstIndex === 0) ? 'text-light' : 'text-primary'}`}
                                                                style={{ cursor: (ind + firstIndex === 0) ? 'default' : 'pointer' }}
                                                                onClick={() => handleMoveOrder(ind, 'up')}
                                                            /> */}
                                                            <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold', width: '20px' }}>{item.DisplayOrder || 0}</h6>
                                                            {/* <FaArrowDown
                                                                className={`ms-2 ${ (ind + firstIndex === blogs.length - 1) ? 'text-light' : 'text-primary'}`}
                                                                style={{ cursor: (ind + firstIndex === blogs.length - 1) ? 'default' : 'pointer' }}
                                                                onClick={() => handleMoveOrder(ind, 'down')}
                                                            /> */}
                                                        </div>
                                                    </td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Title}</h6>
                                                        </div>
                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "100px" }}>
                                                        <div className="d-flex justify-content-center">
                                                            <CiEdit cursor='pointer' title='Edit UGC Home Page' size={20} className='text-primary me-2' onClick={() => childRef.current.openModal(item)} />
                                                            <MdDeleteOutline onClick={() => deleteItem(item.Sn, 'About', '/ugc/deleteAbout/', setBlogsLoading, loadBlogs)} color="red" title='Delete' cursor='pointer' size={20} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(blogs, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UGC_AboutsModal ref={childRef} loadBlogs={loadBlogs} setBlogsLoading={setBlogsLoading} />
        </>
    )
}

export default UGC_Abouts;
